import { createApp } from 'vue'
import { createPinia } from 'pinia'
import naive from 'naive-ui'
import { router } from './router'
import { useAuthStore } from './stores/auth'
import { i18n, localeBundle, type AppLocale } from './i18n'
import App from './App.vue'
import './styles/global.css'

// Reflect the initial locale on <html lang=…> so screen readers and Chrome's
// translate prompt behave correctly on first paint.
if (typeof document !== 'undefined') {
  const initial = i18n.global.locale.value as AppLocale
  document.documentElement.lang = localeBundle(initial).htmlLang
}

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(naive)
app.use(i18n)
app.mount('#app')

// When the API layer detects an unrecoverable auth failure (refresh missing or
// rejected by the backend), it dispatches `auth:expired` on the window. We
// clear local auth state and bounce the user to /login with a redirect query
// so they land back on the page they were trying to use after re-authing.
window.addEventListener('auth:expired', () => {
  const auth = useAuthStore()
  auth.logout()
  const current = router.currentRoute.value
  if (current.name === 'login') return
  router.push({ name: 'login', query: { redirect: current.fullPath } })
})
